import React from 'react';

const SubmitButtons = ({ readOnly, showQATab, handleQASubmitClick, handleLoadSubmitClick, disableSubmit }) => {
  if (readOnly) return <></>;
  return (
    <div className="d-flex justify-content-between">
      {showQATab ? (
        <button className="blue-button-newload nl-save" onClick={handleQASubmitClick} disabled={disableSubmit}>
          <span>Submit QA</span>
        </button>
      ) : (
        <button className="blue-button-newload nl-save" onClick={handleLoadSubmitClick} disabled={disableSubmit}>
          <span>Submit Load</span>
        </button>
      )}
    </div>
  );
};

export default SubmitButtons;
